module.exports = __webpack_public_path__ + "img/logo.d2c85b3d.png";